import ContactForm from "../../../components/ContactForm";
import Section from "../../../components/Section";
import SectionLayout from "../../../components/[przyjaznedeklaracje]/_sectionLayout";

import DeclarationBox from "../../../components/DeclarationBox";
import DeclarationBoxItem from "../../../components/DeclarationBoxItem";
import DeclarationModal from "../../../components/DeclarationModal";

import Variables from "../../../variables/variables.json";
import BackButton from "../../../components/BackButton";

import Nieruchomosci from "../../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/section-1_pl.mdx";
import DeclarationBoxIndividual from "../../../components/DeclarationBoxIndividual";
import BackgroundSection from "../../../components/BackgroundSection";
import SectionBox from "../../../components/SectionBox";
import CustomListWithZero from "../../../components/CustomListWithZero";
import FAQ from "../../../components/FAQ";
import YoutubeSlider from "../../../components/YoutubeSlider";

import DeklaracjaDN11 from "../../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/deklaracja-dn-1/section-1_pl.mdx";
import DeklaracjaDN12 from "../../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/deklaracja-dn-1/section-2_pl.mdx";
import DeklaracjaDN13 from "../../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/deklaracja-dn-1/section-3_pl.mdx";
import DeklaracjaDN14 from "../../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/deklaracja-dn-1/section-4_pl.mdx";
import DeklaracjaDN15 from "../../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/deklaracja-dn-1/section-5_pl.mdx";
import DeklaracjaDN16 from "../../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/deklaracja-dn-1/section-6_pl.mdx";

import videos from "../../../data/youtubeVideos.json";

export default function DeklaracjaDN1(props) {
	let Miasto = "PRZYJAZNEDEKLARACJE";
	let Podatek = "deklaracjadn1";

	return (
		<SectionLayout miasto={Miasto} podatek={Podatek} typeHero="slider" breadcrumbsLayout="light">
			<Section mdx>
				<DeklaracjaDN11 />
			</Section>

			<Section mdx lighterdark noPanel>
				<DeklaracjaDN12 />
			</Section>

			<Section bigPaddingTop>
				<div className="declaration-box-individual__columns">
					<DeclarationBoxIndividual podatek="dn1" top noReadMore btnPrimary button="link" />
					<DeclarationBoxIndividual podatek="in1notdn1" noShadow noAction />
				</div>
			</Section>

			<Section mdx>
				<DeklaracjaDN13 />
				<DeklaracjaDN14 />

				<YoutubeSlider
					title="Poradniki Video krok po kroku"
					items={videos}
					cardWidth={640}
					openInModal={true}
				/>
			</Section>

			<BackgroundSection
				miasto={Miasto}
				section="deklaracjadn1"
				attachment
				textAlign="left"
				button="primary"
				title
				subtitle
				bgColor="shadow"
			/>

			<Section mdx lighterdark>
				<DeklaracjaDN15 />

				<CustomListWithZero miasto={Miasto} section="deklaracjadn1" />

				<br />

				<DeklaracjaDN16 />
			</Section>

			<BackgroundSection
				miasto={Miasto}
				section="deklaracjadn1"
				attachment
				textAlign="left"
				button="primary"
				title
				subtitle
				bgColor="shadow"
			/>

			<Section title="sections.czestozadawanepytania.title" id="czesto-zadawane-pytania-faq">
				<FAQ miasto={Miasto} section="deklaracjadn1" secondary />
			</Section>

			<Section>
				<h2 class="pd-section__title">Druki DN-1 i załączniki ZDN-1, ZDN-2 do pobrania</h2>
				<div class="pd-tabs__contents__wrapper">
					<div
						class="pd-tabs__contents"
						id="panel-1"
						role="tabpanel"
						tabindex="0"
						aria-labelledby="tab-1"
						hidden=""
					>
						<div class="row center-xs">
							<div class="pd-tabs__column pd-tabs__title col-md-8 col-xs-12">
								<span class="sr-only">Nazwa dokumentu: </span>Druk DN-1 - Deklaracja na podatek od
								nieruchomości (PDF)
							</div>
							<div class="pd-tabs__column col-md-2 col-xs-12">
								<a
									class="pd-tabs__action"
									href="https://www.podatki.gov.pl/media/ixlngt0h/dn1-01-23.pdf"
								>
									<div class="pd-tabs__action__icon__container">
										<span class="pd-tabs__action__icon pd-tabs__action__icon--normal">
											<img
												alt=""
												loading="lazy"
												width="26"
												height="17"
												decoding="async"
												data-nimg="1"
												src="https://przyjazne-deklaracje.pl/resources/images/icons/general/section/dokumenty-i-uchwaly/visibility.svg"
											/>
										</span>
										<span class="pd-tabs__action__icon pd-tabs__action__icon--black">
											<img
												alt=""
												loading="lazy"
												width="26"
												height="17"
												decoding="async"
												data-nimg="1"
												src="https://przyjazne-deklaracje.pl/resources/images/icons/general/section/dokumenty-i-uchwaly/visibility-black.svg"
											/>
										</span>
										<span class="pd-tabs__action__icon pd-tabs__action__icon--highcontrast">
											<img
												alt=""
												loading="lazy"
												width="26"
												height="17"
												decoding="async"
												data-nimg="1"
												src="https://przyjazne-deklaracje.pl/resources/images/icons/general/section/dokumenty-i-uchwaly/visibility-highcontrast.svg"
											/>
										</span>
									</div>
									<span class="pd-tabs__action__text">Podgląd</span>
								</a>
							</div>
						</div>
					</div>
					<div
						class="pd-tabs__contents"
						id="panel-1"
						role="tabpanel"
						tabindex="0"
						aria-labelledby="tab-1"
						hidden=""
					>
						<div class="row center-xs">
							<div class="pd-tabs__column pd-tabs__title col-md-8 col-xs-12">
								<span class="sr-only">Nazwa dokumentu: </span>Druk ZDN-1 - Załącznik do deklaracji
								na podatek od nieruchomości (PDF)
							</div>
							<div class="pd-tabs__column col-md-2 col-xs-12">
								<a
									class="pd-tabs__action"
									href="https://www.podatki.gov.pl/media/ky0nqqce/zdn1-01-17.pdf"
								>
									<div class="pd-tabs__action__icon__container">
										<span class="pd-tabs__action__icon pd-tabs__action__icon--normal">
											<img
												alt=""
												loading="lazy"
												width="26"
												height="17"
												decoding="async"
												data-nimg="1"
												src="https://przyjazne-deklaracje.pl/resources/images/icons/general/section/dokumenty-i-uchwaly/visibility.svg"
											/>
										</span>
										<span class="pd-tabs__action__icon pd-tabs__action__icon--black">
											<img
												alt=""
												loading="lazy"
												width="26"
												height="17"
												decoding="async"
												data-nimg="1"
												src="https://przyjazne-deklaracje.pl/resources/images/icons/general/section/dokumenty-i-uchwaly/visibility-black.svg"
											/>
										</span>
										<span class="pd-tabs__action__icon pd-tabs__action__icon--highcontrast">
											<img
												alt=""
												loading="lazy"
												width="26"
												height="17"
												decoding="async"
												data-nimg="1"
												src="https://przyjazne-deklaracje.pl/resources/images/icons/general/section/dokumenty-i-uchwaly/visibility-highcontrast.svg"
											/>
										</span>
									</div>
									<span class="pd-tabs__action__text">Podgląd</span>
								</a>
							</div>
						</div>
					</div>
					<div
						class="pd-tabs__contents"
						id="panel-1"
						role="tabpanel"
						tabindex="0"
						aria-labelledby="tab-1"
						hidden=""
					>
						<div class="row center-xs">
							<div class="pd-tabs__column pd-tabs__title col-md-8 col-xs-12">
								<span class="sr-only">Nazwa dokumentu: </span>Druk ZDN-2 - Załącznik do deklaracji
								na podatek od nieruchomości (PDF)
							</div>
							<div class="pd-tabs__column col-md-2 col-xs-12">
								<a
									class="pd-tabs__action"
									href="https://www.podatki.gov.pl/media/lsdn43fv/zdn2-01-13.pdf"
								>
									<div class="pd-tabs__action__icon__container">
										<span class="pd-tabs__action__icon pd-tabs__action__icon--normal">
											<img
												alt=""
												loading="lazy"
												width="26"
												height="17"
												decoding="async"
												data-nimg="1"
												src="https://przyjazne-deklaracje.pl/resources/images/icons/general/section/dokumenty-i-uchwaly/visibility.svg"
											/>
										</span>
										<span class="pd-tabs__action__icon pd-tabs__action__icon--black">
											<img
												alt=""
												loading="lazy"
												width="26"
												height="17"
												decoding="async"
												data-nimg="1"
												src="https://przyjazne-deklaracje.pl/resources/images/icons/general/section/dokumenty-i-uchwaly/visibility-black.svg"
											/>
										</span>
										<span class="pd-tabs__action__icon pd-tabs__action__icon--highcontrast">
											<img
												alt=""
												loading="lazy"
												width="26"
												height="17"
												decoding="async"
												data-nimg="1"
												src="https://przyjazne-deklaracje.pl/resources/images/icons/general/section/dokumenty-i-uchwaly/visibility-highcontrast.svg"
											/>
										</span>
									</div>
									<span class="pd-tabs__action__text">Podgląd</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</Section>

			<Section id="wypelnij-deklaracje" title="sections.wypelnijdeklaracje.title">
				<DeclarationBox center>
					<DeclarationBoxItem miasto={Miasto} podatek={Podatek} noReadMore />
				</DeclarationBox>
				<DeclarationModal miasto={Miasto} podatek={Podatek} />
			</Section>

			<Section>
				<BackButton />
			</Section>
		</SectionLayout>
	);
}
